import styled from "styled-components/macro";

export const Container = styled.div`
  outline: none;

  .ProseMirror {
    &::selection, & *::selection {
      background: var(--text-highlight);
    }
    &::-moz-selection, & *::-moz-selection {
      background: var(--text-highlight);
    }
  }

  > div {
    outline: none;
    background: none;
    color: var(--grey-0);
    padding: 7px;
    border-radius: 6px;
  }

  > div > div {
    outline: none;
  }

  insert, ins {
    color: var(--primary-cta-high-contrast);
    font-weight: 400;
    text-decoration: none;
    display: inline;
  }

  delete, del {
    color: var(--grey-2);
    text-decoration: line-through;
    display: inline;
  }

  /* Search highlight styles - match editor theme */
  .search-highlight {
    background-color: var(--text-highlight);
    border-radius: 2px;
  }

  .search-highlight-selected {
    background-color: var(--primary-cta-transparent-30);
    outline: 1px solid var(--primary-cta-high-contrast);
  }

  .ProseMirror p + p {
    margin-top: 0.75em;
  }

  ul {
    list-style-type: disc !important;
    padding-left: 1.5em;
    margin: 0.5em 0;
  }

  ol {
    list-style-type: decimal !important;
    padding-left: 1.5em;
    margin: 0.5em 0;
  }

  li {
    list-style: inherit !important;
    display: list-item !important;
    margin: 0.25em 0;
  }

  li p {
    margin: 0;
  }

  &.field-limit-exceeded > div {
    box-shadow: inset 0 0 0 1px var(--error-red, #d14343);
    border-radius: 6px;
  }

  hr {
    border: none;
    border-top: 1px solid var(--grey-3);
    margin: 1em 0;
  }
`;
